define('SuiteDynamics.PickedForYouHomepage.Entrypoint',
	[
		'SuiteDynamics.PickedForYouHomepage.Slider'
	],
	function (
		Slider
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {
			Slider.mountToApp(container)
		}
	};
});
